import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";

const NAV = [
  { to: "/artistes", label: "Artistes & projets" },
  { to: "/actualites", label: "Actualités" },
  { to: "/editions", label: "Créations Joy Messenger" },
  { to: "/boutique", label: "Boutique" },
  { to: "/jukebox", label: "Jukebox" },
  { to: "/soutenir", label: "Soutenir" },
];

const PRO = [
  { to: "/presse", label: "Espace professionnel" },
  { to: "/presse", label: "Dossiers de presse" },
  { to: "/contact", label: "Booking" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#08090C] border-t border-jm-brass/15 mt-0">
      <div className="jm-container py-16 sm:py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="jm-overline mb-5">Navigation</p>
          <ul className="space-y-2.5">
            {NAV.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-jm-smoke hover:text-jm-bone transition-colors duration-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <p className="jm-overline mb-5">Pro</p>
          <ul className="space-y-2.5">
            {PRO.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-jm-smoke hover:text-jm-bone transition-colors duration-300">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="jm-overline mb-4 mt-8">Contact</p>
          <a href="mailto:contact@joymessenger.fr" className="text-sm text-jm-smoke hover:text-jm-bone transition-colors">
            contact@joymessenger.fr
          </a>
        </div>
        <div className="lg:col-span-5">
          <p className="jm-overline mb-5">Newsletter</p>
          <NewsletterForm compact />
          <div className="flex gap-4 mt-8">
            {["Instagram", "YouTube", "Bandcamp"].map((s) => (
              <a
                key={s}
                href="#"
                data-testid={`footer-social-${s.toLowerCase()}`}
                className="font-mono text-[10px] uppercase tracking-[0.2em] text-jm-mute hover:text-jm-brass transition-colors"
              >
                {s}
              </a>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-jm-brass/10">
        <div className="jm-container py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-jm-mute">© 2026 Joy Messenger — Association loi 1901. Tous droits réservés.</p>
          <div className="flex gap-6">
            <span className="text-xs text-jm-mute">Mentions légales</span>
            <span className="text-xs text-jm-mute">Confidentialité</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
